import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="package-selection"
export default class extends Controller {
  static targets = ["card", "button", "continueButton", "upgradeIdInput"]
  static values = { 
    selectedUpgradeId: String 
  }

  connect() {
    console.log("Package selection controller connected")
    
    // Auto-select package if selected_upgrade_id is provided
    if (this.selectedUpgradeIdValue) {
      this.autoSelectPackage(this.selectedUpgradeIdValue)
    }
  }
  
  autoSelectPackage(upgradeId) {
    // Find the card with the matching upgrade_id
    const targetCard = this.cardTargets.find(card => card.dataset.upgradeId === upgradeId)
    
    if (targetCard) {
      // Select the card
      this.selectCard(targetCard)
      
      // Update the hidden input
      if (this.hasUpgradeIdInputTarget) {
        this.upgradeIdInputTarget.value = upgradeId
      }
      
      // Scroll to the selected card smoothly
      setTimeout(() => {
        targetCard.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }, 100)
    }
  }

  select(event) {
    event.preventDefault()
    
    const clickedCard = event.currentTarget.closest("[data-package-selection-target='card']")
    const upgradeId = clickedCard.dataset.upgradeId
    const isCurrentlySelected = clickedCard.classList.contains("selected")
    
    // If clicking on already selected card, deselect it
    if (isCurrentlySelected) {
      this.deselectCard(clickedCard)
      
      // Clear the stored upgrade_id
      this.selectedUpgradeIdValue = ""
      
      // Clear the hidden input
      if (this.hasUpgradeIdInputTarget) {
        this.upgradeIdInputTarget.value = ""
      }
      
      return
    }
    
    // Deselect all cards first
    this.cardTargets.forEach(card => {
      this.deselectCard(card)
    })
    
    // Select the clicked card
    this.selectCard(clickedCard)
    
    // Store the selected upgrade_id
    this.selectedUpgradeIdValue = upgradeId
    
    // Update the hidden input with the upgrade_id
    if (this.hasUpgradeIdInputTarget) {
      this.upgradeIdInputTarget.value = upgradeId
    }
  }
  
  selectCard(card) {
    card.classList.add("selected")
    card.classList.remove("border-gray-200", "shadow-md")
    card.classList.add("border-green-400", "shadow-xl")
    
    // Update the button to show selected state
    const button = card.querySelector("[data-package-selection-target='button']")
    if (button) {
      button.classList.remove("bg-brand", "hover:bg-brand-light")
      button.classList.add("bg-green-400", "hover:bg-green-500")
      button.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M20 6L9 17l-5-5"></path>
        </svg>
        Selected
      `
    }
  }
  
  deselectCard(card) {
    card.classList.remove("selected")
    card.classList.remove("border-green-400", "shadow-xl")
    card.classList.add("border-gray-200", "shadow-md")
    
    // Update the button to show unselected state
    const button = card.querySelector("[data-package-selection-target='button']")
    if (button) {
      button.classList.remove("bg-green-400", "hover:bg-green-500")
      button.classList.add("bg-brand", "hover:bg-brand-light")
      button.innerHTML = "Select Package"
    }
  }

  viewInfo(event) {
    // Allow the view info link to work normally (don't prevent default)
    // This will navigate to the upgrade details page
  }
}

